<template>
  <div class="about">
    <h1>This is a about page</h1>
  </div>
</template>
